import React, { useState, useMemo } from 'react';

// Маппинг полей для отображения (статический fallback)
const FIELD_MAPPING = {
  'id': { name: 'ID', type: 'number' },
  'title': { name: 'Название', type: 'string' },
  'ufCrm3_1746789101': { name: 'Номер заказа', type: 'string' },
  'stageId': { name: 'Стадия', type: 'stage' },
  'createdTime': { name: 'Создан', type: 'date' },
  'updatedTime': { name: 'Обновлен', type: 'date' },
  'assignedById': { name: 'Ответственный', type: 'user' },
  'opportunity': { name: 'Сумма', type: 'money' },
  'companyId': { name: 'ID компании', type: 'number' },
  'contactId': { name: 'ID контакта', type: 'number' },
  'createdBy': { name: 'Создан пользователем', type: 'number' },
  
  // Все пользовательские поля с реальными названиями
  'ufCrm3_1746789363': { name: 'Товары', type: 'string' },
  'ufCrm3_1746789446': { name: 'ID-B2C', type: 'string' },
  'ufCrm3_1746789468': { name: 'ID-B2B', type: 'string' },
  'ufCrm3_1746789474': { name: 'ID-Франчайзи', type: 'string' },
  'ufCrm3_1746789572': { name: 'Триггер: Матовка', type: 'string' },
  'ufCrm3_1746789589': { name: 'Триггер: упаковка', type: 'string' },
  'ufCrm3_1746789599': { name: 'Триггер: Фурнитура', type: 'string' },
  'ufCrm3_1746789627': { name: 'Триггер: Закалка', type: 'string' },
  'ufCrm3_1746789650': { name: 'Триггер: LOFT / Зеркало', type: 'string' },
  'ufCrm3_1746789862': { name: 'Файл договора', type: 'file' },
  'ufCrm3_1746789890': { name: 'Дизайн чертежа', type: 'file' },
  'ufCrm3_1746789910': { name: 'Деталировка чертежа', type: 'file' },
  'ufCrm3_1746790033': { name: 'Данные по замеру', type: 'file' },
  'ufCrm3_1746790136': { name: 'Чертеж "загрузите старый чертеж до переделки"', type: 'file' },
  'ufCrm3_1746790327': { name: 'Ответственный за чертеж:', type: 'user' },
  'ufCrm3_1746790893': { name: 'Ответственный за замер:', type: 'string' },
  'ufCrm3_1746791181': { name: 'Ответственный за фурнитуру:', type: 'user' },
  'ufCrm3_1747750785257': { name: 'Триггер: Сырое стекло', type: 'string' },
  'ufCrm3_1749212561933': { name: 'Ответственный за обработку и сверловку стекла', type: 'string' },
  'ufCrm3_1749212579499': { name: 'Ответственный за резку стекла', type: 'string' },
  'ufCrm3_1749212591302': { name: 'Ответственный за матировку стекла', type: 'string' },
  'ufCrm3_1749212635898': { name: 'Ответственный за сборку лофта и зеркала', type: 'string' },
  'ufCrm3_1749212685683': { name: 'Ответственный за сборку фурнитуры', type: 'string' },
  'ufCrm3_1749212694990': { name: 'Ответственный за упаковку', type: 'string' },
  'ufCrm3_1749212719306': { name: 'Ответственный за закалку', type: 'string' },
  'ufCrm3_1749212970874': { name: 'Источник стекла душевой перегородки (Поставщик стекла)', type: 'string' },
  'ufCrm3_1749212997464': { name: 'Источник стекла LOFT перегородки (Поставщик стекла)', type: 'string' },
  'ufCrm3_1749213049974': { name: 'Ответственный за установку (ФИО, телефон)', type: 'string' },
  'ufCrm3_1749213064008': { name: 'Ответственный за отправку', type: 'string' },
  'ufCrm3_1749213221666': { name: 'Накладной документ от службы доставки', type: 'file' },
  'ufCrm3_1749213244986': { name: 'Дата передачи заказа в службу доставки', type: 'date' },
  'ufCrm3_1749213340553': { name: 'Данные по установке (фото и видео)', type: 'file' },
  'ufCrm3_1749213350972': { name: 'Дата завершения установки', type: 'date' },
  'ufCrm3_1749213376934': { name: 'Документ: АВР (акт выполненных работ)', type: 'file' },
  'ufCrm3_1749475648149': { name: 'Данные по упаковке (фото и видео)', type: 'file' },
  'ufCrm3_1749555592378': { name: 'Дата завершения упаковки', type: 'date' },
  'ufCrm3_1751274844238': { name: 'Прозрачный 8 мм.', type: 'string' },
  'ufCrm3_1751274861103': { name: 'Бронза 8 мм.', type: 'string' },
  'ufCrm3_1751275030885': { name: 'Прозрачный 4 мм.', type: 'string' },
  'ufCrm3_1751275041994': { name: 'Бронза 4 мм.', type: 'string' },
  'ufCrm3_1751275363654': { name: 'Прозрачный 6 мм.', type: 'string' },
  'ufCrm3_1751275374960': { name: 'Прозрачный 10 мм.', type: 'string' },
  'ufCrm3_1751279653655': { name: 'Графит 8 мм.', type: 'string' },
  'ufCrm3_1751344784096': { name: 'Резка запись для Лютер', type: 'string' },
  'ufCrm3_1751344871698': { name: 'Итог Резка', type: 'string' },
  'ufCrm3_1751344928901': { name: 'Резка коментарии', type: 'string' },
  'ufCrm3_1751370238766': { name: 'Сверловка запись для Лютер', type: 'string' },
  'ufCrm3_1751370309345': { name: 'Сверловка коментарии', type: 'string' },
  'ufCrm3_1751370446708': { name: 'Серловка итог', type: 'string' }
};

// Функция получения названия стадии
const getStageNameById = (stageId) => {
  const stages = {
    // Категория 6
    'DT1036_6:NEW': 'Новая заявка',
    'DT1036_6:UC_58B1IG': 'Резка стекла',
    'DT1036_6:UC_HD3BPN': 'Обработка стекла',
    'DT1036_6:UC_PBEINX': 'На закалке',
    'DT1036_6:UC_4FXLEO': 'Матировка',
    'DT1036_6:UC_WE1KJE': 'Сборка лофта',
    'DT1036_6:UC_SNLWF9': 'Упаковка',
    'DT1036_6:UC_ZZP9IY': 'Комплектация',
    'DT1036_6:SUCCESS': 'Выполнен',
    
    // Категория 7  
    'DT1036_7:NEW': 'Новая заявка',
    'DT1036_7:UC_58B1IG': 'Резка стекла',
    'DT1036_7:UC_HD3BPN': 'Обработка стекла',
    'DT1036_7:UC_PBEINX': 'На закалке',
    'DT1036_7:UC_4FXLEO': 'Матировка',
    'DT1036_7:UC_WE1KJE': 'Сборка лофта',
    'DT1036_7:UC_SNLWF9': 'Упаковка',
    'DT1036_7:UC_ZZP9IY': 'Комплектация',
    'DT1036_7:SUCCESS': 'Выполнен'
  };
  return stages[stageId] || `Неизвестная стадия (${stageId})`;
};

// Функция форматирования значения поля
const formatFieldValue = (field, value, deal) => {
  if (!value && value !== 0 && value !== false) return '-';

  switch (field.type) {
    case 'date':
      try {
        const date = new Date(value);
        if (isNaN(date.getTime())) return '-';
        return date.toLocaleDateString('ru-RU');
      } catch {
        return '-';
      }
    
    case 'number':
      if (field.id === 'opportunity') {
        return new Intl.NumberFormat('ru-RU', {
          style: 'currency',
          currency: 'KZT'
        }).format(value);
      }
      return String(value);
    
    case 'select':
      return getStageNameById(value);
    
    case 'user':
      if (typeof value === 'object' && value.name) {
        return value.name;
      }
      if (value) return `Пользователь ${value}`;
      return '-';
    
    case 'file':
      if (Array.isArray(value) && value.length > 0) {
        return `Файлов: ${value.length}`;
      }
      if (value && typeof value === 'object') {
        return 'Есть файл';
      }
      return '-';
    
    default:
      // Обработка строк, которые могут содержать JSON
      if (typeof value === 'string') {
        // Проверяем, является ли строка JSON
        if ((value.startsWith('{') && value.endsWith('}')) || 
            (value.startsWith('[') && value.endsWith(']'))) {
          try {
            const parsedJson = JSON.parse(value);
            
            // Если это массив
            if (Array.isArray(parsedJson)) {
              if (parsedJson.length === 0) return 'Пустой массив';
              const itemsText = parsedJson.map(item => {
                if (typeof item === 'object' && item !== null) {
                  return item.name || item.title || item.value || JSON.stringify(item);
                }
                return String(item);
              }).join(', ');
              
              return itemsText;
            }
            
            // Если это объект
            if (typeof parsedJson === 'object' && parsedJson !== null) {
              const keys = Object.keys(parsedJson);
              if (keys.length === 0) return 'Пустой объект';
              
              // Пытаемся найти осмысленные поля
              if (parsedJson.name) return parsedJson.name;
              if (parsedJson.title) return parsedJson.title;
              if (parsedJson.value) return parsedJson.value;
              if (parsedJson.text) return parsedJson.text;
              
              // Показываем все ключи
              const keyValues = keys.map(key => `${key}: ${parsedJson[key]}`).join(', ');
              return keyValues;
            }
            
            return String(parsedJson);
          } catch (e) {
            // Если не удалось распарсить JSON, возвращаем как есть
            return value;
          }
        }
        
        // Обычная строка - показываем полностью
        return value;
      }
      
      // Обработка массивов - показываем полное содержимое
      if (Array.isArray(value)) {
        if (value.length === 0) return '-';
        
        // Показываем все элементы массива
        const itemsText = value.map(item => {
          if (typeof item === 'object' && item !== null) {
            return item.name || item.title || item.value || JSON.stringify(item);
          }
          return String(item);
        }).join(', ');
        
        return itemsText;
      }
      
      // Обработка объектов
      if (typeof value === 'object' && value !== null) {
        if (value.name) return value.name;
        if (value.title) return value.title;
        if (value.value) return value.value;
        if (value.url) return 'Ссылка';
        
        // Попытка показать содержимое объекта
        const keys = Object.keys(value);
        if (keys.length > 0) {
          const firstKey = keys[0];
          return `${firstKey}: ${value[firstKey]}`;
        }
        return 'Объект';
      }
      
      return String(value);
  }
};

// Компонент загрузки
const LoadingSpinner = () => (
  <div className="flex items-center justify-center py-12">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mr-3"></div>
    <span className="text-gray-600">Загрузка данных...</span>
  </div>
);

// Компонент ошибки
const ErrorMessage = ({ error, onRetry }) => (
  <div className="bg-red-50 border border-red-200 rounded-lg p-4 my-4">
    <div className="flex items-center">
      <svg className="h-5 w-5 text-red-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
      </svg>
      <div>
        <h3 className="text-sm font-medium text-red-800">Ошибка загрузки</h3>
        <p className="text-sm text-red-600 mt-1">{error}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="mt-2 text-sm bg-red-100 hover:bg-red-200 text-red-800 px-3 py-1 rounded transition-colors"
          >
            Повторить попытку
          </button>
        )}
      </div>
    </div>
  </div>
);

// Основной компонент списка сделок с автоматическими колонками
const DealsListAuto = ({ 
  deals = [], 
  loading = false, 
  error = null, 
  totalCount = 0,
  selectedFields = ['ufCrm3_1746789101', 'createdTime'], // Поля для отображения
  fieldMetadata = {},
  onRetry,
  showExportButton = true 
}) => {
  const [sortField, setSortField] = useState('updatedTime');
  const [sortOrder, setSortOrder] = useState('desc');
  const [selectedDeals, setSelectedDeals] = useState(new Set());

  // Получение информации о колонках на основе selectedFields
  const columnInfo = useMemo(() => {
    return selectedFields.map(fieldId => {
      // Сначала проверяем метаданные из Bitrix
      if (fieldMetadata[fieldId]) {
        const field = fieldMetadata[fieldId];
        let fieldType = 'string';
        
        if (field.type === 'integer' || field.type === 'double') {
          fieldType = 'number';
        } else if (field.type === 'date' || field.type === 'datetime') {
          fieldType = 'date';
        } else if (field.listItems && Object.keys(field.listItems).length > 0) {
          fieldType = 'select';
        }

        return {
          id: fieldId,
          name: field.title || field.formLabel || fieldId,
          type: fieldType
        };
      }
      
      // Fallback на статический маппинг
      return {
        id: fieldId,
        ...FIELD_MAPPING[fieldId],
        name: FIELD_MAPPING[fieldId]?.name || fieldId
      };
    }).filter(Boolean);
  }, [selectedFields, fieldMetadata]);

  // Сортировка сделок
  const sortedDeals = useMemo(() => {
    if (!deals.length) return [];

    const sorted = [...deals].sort((a, b) => {
      let aVal = a[sortField];
      let bVal = b[sortField];

      if (sortField.includes('Time') || sortField.includes('Date')) {
        aVal = new Date(aVal || 0).getTime();
        bVal = new Date(bVal || 0).getTime();
      }

      if (typeof aVal === 'string' && !isNaN(aVal)) {
        aVal = Number(aVal);
        bVal = Number(bVal);
      }

      if (typeof aVal === 'string' && typeof bVal === 'string') {
        aVal = aVal.toLowerCase();
        bVal = bVal.toLowerCase();
      }

      if (sortOrder === 'asc') {
        return aVal > bVal ? 1 : -1;
      } else {
        return aVal < bVal ? 1 : -1;
      }
    });

    return sorted;
  }, [deals, sortField, sortOrder]);

  // Обработчик сортировки
  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('desc');
    }
  };

  // Рендер иконки сортировки
  const renderSortIcon = (field) => {
    if (sortField !== field) {
      return (
        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
        </svg>
      );
    }

    return sortOrder === 'asc' ? (
      <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
      </svg>
    ) : (
      <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    );
  };

  // Обработчики выбора элементов
  const toggleDeal = (dealId) => {
    const newSelected = new Set(selectedDeals);
    if (newSelected.has(dealId)) {
      newSelected.delete(dealId);
    } else {
      newSelected.add(dealId);
    }
    setSelectedDeals(newSelected);
  };

  const toggleAllDeals = () => {
    if (selectedDeals.size === sortedDeals.length) {
      setSelectedDeals(new Set());
    } else {
      setSelectedDeals(new Set(sortedDeals.map(deal => deal.id)));
    }
  };

  // Экспорт в CSV
  const exportToCSV = () => {
    const dealsToExport = selectedDeals.size > 0 
      ? sortedDeals.filter(deal => selectedDeals.has(deal.id))
      : sortedDeals;

    if (dealsToExport.length === 0) return;

    const headers = columnInfo.map(col => col.name);
    
    const csvData = [
      headers,
      ...dealsToExport.map(deal => 
        columnInfo.map(col => {
          const value = deal[col.id];
          const formattedValue = formatFieldValue(col, value, deal);
          return formattedValue.includes(',') || formattedValue.includes('"') 
            ? `"${formattedValue.replace(/"/g, '""')}"` 
            : formattedValue;
        })
      )
    ];

    const csvContent = csvData.map(row => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.download = `deals_export_${new Date().toISOString().split('T')[0]}.csv`;
    link.click();
    
    URL.revokeObjectURL(url);
  };

  if (loading && deals.length === 0) {
    return <LoadingSpinner />;
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border">
      {/* Заголовок */}
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              Результаты поиска
            </h3>
            <p className="text-sm text-gray-600 mt-1">
              Найдено: {totalCount} записей
              {selectedDeals.size > 0 && ` • Выбрано: ${selectedDeals.size}`}
            </p>
            <p className="text-xs text-gray-500 mt-1">
              Отображаемые колонки: {columnInfo.map(col => col.name).join(', ')}
            </p>
          </div>

          <div className="flex items-center space-x-3">
            {showExportButton && sortedDeals.length > 0 && (
              <button
                onClick={exportToCSV}
                className="px-4 py-2 text-sm bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors focus:outline-none focus:ring-2 focus:ring-green-500"
                title={selectedDeals.size > 0 ? `Экспортировать выбранные (${selectedDeals.size})` : `Экспортировать все (${sortedDeals.length})`}
              >
                <svg className="w-4 h-4 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                Экспорт CSV
              </button>
            )}
          </div>
        </div>
      </div>

      {error && <ErrorMessage error={error} onRetry={onRetry} />}

      {/* Таблица */}
      {sortedDeals.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="w-full table-auto">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left w-12">
                  <input
                    type="checkbox"
                    checked={selectedDeals.size === sortedDeals.length && sortedDeals.length > 0}
                    onChange={toggleAllDeals}
                    className="rounded border-gray-300 focus:ring-2 focus:ring-blue-500"
                    aria-label="Выбрать все"
                  />
                </th>
                {columnInfo.map(column => (
                  <th 
                    key={column.id}
                    className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSort(column.id)}
                  >
                    <div className="flex items-center space-x-1">
                      <span>{column.name}</span>
                      {renderSortIcon(column.id)}
                    </div>
                  </th>
                ))}
                
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {sortedDeals.map((deal, index) => (
                <tr 
                  key={deal.id} 
                  className={`hover:bg-gray-50 ${selectedDeals.has(deal.id) ? 'bg-blue-50' : ''}`}
                >
                  <td className="px-4 py-4">
                    <input
                      type="checkbox"
                      checked={selectedDeals.has(deal.id)}
                      onChange={() => toggleDeal(deal.id)}
                      className="rounded border-gray-300 focus:ring-2 focus:ring-blue-500"
                      aria-label={`Выбрать запись ${deal.id}`}
                    />
                  </td>
                  {columnInfo.map(column => {
                    const value = deal[column.id];
                    const hasValue = value !== undefined && value !== null && value !== '';
                    
                    return (
                      <td 
                        key={column.id} 
                        className={`px-4 py-4 text-sm ${hasValue ? 'text-gray-900' : 'text-gray-400'} max-w-xs break-words`}
                        title={`${column.name}: ${hasValue ? value : 'Нет данных'}`}
                      >
                        {formatFieldValue(column, value, deal)}
                      </td>
                    );
                  })}
                  
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="p-12 text-center">
          <svg className="w-12 h-12 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <h3 className="text-lg font-medium text-gray-900 mb-2">Нет данных</h3>
          <p className="text-gray-500 mb-4">
            Измените параметры фильтрации или создайте новый поиск
          </p>
        </div>
      )}

      {loading && deals.length > 0 && (
        <div className="p-4 text-center border-t">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mx-auto"></div>
        </div>
      )}
    </div>
  );
};

export default DealsListAuto;